import ApiService from '@/services/api.service'


const OmniCellInBounds = {
    getAll( parameter) { 
         
      const requestData = {
        method: 'get',
        url: "/OmniCellInBounds",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
        }
      }     
      return ApiService.customRequest(requestData);         
    },

    getAllOmniCellInBounds(RecordId){
        return ApiService.get(`/OmniCellInBounds/?RecordId=${RecordId}`);
    },
  
    get(id) {
      return ApiService.get(`/OmniCellInBounds/${id}`);
    },


    
  }
  
  export default OmniCellInBounds;